import React, { Component } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Row, Col, Container, Button } from "react-bootstrap";
import { sanitizeUrl } from "@braintree/sanitize-url";
import queryString from "query-string";
import WithError from "../common/WithError";
import http from "../../api/http-request";
import { setCookie } from "../../utils/cookies";
import { getLoginUrl, getRoutePath,pageNotFound,randomCount } from "../../utils/common";
import ErrorCard from "../common/ErrorCard";
import SomethingWentWrong from "../common/SomethingWentWrong";
import SystemDownTime from "../common/SystemDownTime";
import Carousel1 from "../../assets/images/reg1.jpg";
import Carousel2 from "../../assets/images/reg2.jpg";
import Carousel3 from "../../assets/images/reg3.jpg";
import Carousel4 from "../../assets/images/reg4.jpg";
import Carousel5 from "../../assets/images/reg5.jpg";
import Carousel6 from "../../assets/images/reg6.jpg";
import Carousel7 from "../../assets/images/reg7.jpg";
import Carousel9 from "../../assets/images/reg9.jpg";

class ResendVerificationEmail extends Component {
  constructor(props) {
    super(props);
    this.emailInputRef = React.createRef();
    this.state = {
      emailError: false,
      mail: "",
      errorText: "",
      token: "",
      showSuccessMsg: "",
      isPageLoaded: false,
      showErrorMsg: false,
      verificationTokenExpired: "",
      isSystemError:false,
      isSomethingError:false,
      carouselImages: [{'image':Carousel3},{'image':Carousel4},{'image':Carousel1},{'image':Carousel2},{'image':Carousel6},{'image':Carousel9},{'image':Carousel5},{'image':Carousel7}],
      imageIndex:null
    };
  }

  componentDidMount() {
    this.renderPageByToken();
    this.displayRandomImage();
  }
  displayRandomImage = () => {
    this.setState({
      imageIndex: randomCount()
    });
  };

  renderPageByToken = () => {
    const {
      location: { search }
    } = this.props;
    const params = queryString.parse(search);
    let environment;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      environment = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      environment = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      environment = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      environment = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      environment = 'ctapproute';
    }
    const { code, token } = queryString.parse(search);
    let ctapproute;
    Object.keys(params).forEach((key) => {
      if(key === environment){
        ctapproute = params[key];
      }
    });
    if (code && token) {
      this.verifyUser(code, token);
    } else {
      this.getToken();
    }
    if (ctapproute) {
      setCookie(`${environment}`, ctapproute);
    }
    if (params.language) {
      setCookie("ctsessionlanguage", params.language);
    }
  };

  verifyUser = (code, token) => {
    http(
      {
        url: "selfservice/resendVerificationEmail?_action=submitRequirements",
        data: {
          input: {
            token,
            code
          },
          token
        },
        method: "POST"
      },
      {
        "X-OpenIDM-NoSession": true,
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.type === 'updateIdentityVerification') {
        const { history } = this.props;
        history.push(sanitizeUrl(`${getRoutePath}/verificationSuccess`));
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.setState({
          verificationTokenExpired: true,
          isPageLoaded: true
        });
      }
    });
  };

  getToken = () => {
    http(
      {
        url: "selfservice/resendVerificationEmail?_action=submitRequirements",
        data: { input: { input: {} } },
        method: "POST"
      },
      {
        "X-OpenIDM-NoSession": true,
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.type === 'userQuery') {
        this.setState({
          token: res.data.token,
          isPageLoaded: true
        });
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else if(res.status === 404 || res.status === 503){
        this.setState({
          isSystemError: true,
          isPageLoaded: false
        });
      }
      else {
        this.setState({
          isPageLoaded: false,
          isSomethingError:true
        });
      }
    });
  };

  isEmailValid = (value) => {
    if (
      value.length <= 0 ||
      !value.match(
        /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
      )
    ) {
      this.setState({
        emailError: true
      });
    } else {
      this.setState({
        emailError: false
      });
    }
  };

  onResendEmail = (e) => {
    e.preventDefault();
    this.emailInputRef.current.blur();
    const { mail, emailError, token } = this.state;
    if (mail === "" || emailError) {
      this.setState({
        emailError: true
      });
      this.showError("common.errors.required");
    } else if (mail !== "" && !emailError) {
      this.showError("");
      http(
        {
          url: "selfservice/resendVerificationEmail?_action=submitRequirements",
          data: {
            input: { queryFilter: `mail eq "${mail}"` },
            token
          },
          method: "POST"
        },
        {
          "X-OpenIDM-NoSession": true,
          "X-OpenIDM-Username": "anonymous",
          "X-OpenIDM-Password": "anonymous"
        }
      ).then((res) => {
        if (res.status === 200 && res.data && res.data.type === 'CTEmailValidation') {
        
          this.setState({
            showSuccessMsg:true
            });
         
        }
        else if(res.status === 200 && res.data && typeof res.data === 'string'){
          pageNotFound(res);
        }  
        else {
          this.setState({
            showErrorMsg: true
          });
          
        }
      });
    }
  };


  showError = (errorText) => {
    this.setState({
      errorText
    });
    if (errorText) {
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
    }
  };

  render() {
    const { t } = this.props;
    const {
      emailError,
      mail,
      errorText,
      showSuccessMsg,
      isPageLoaded,
      showErrorMsg,
      verificationTokenExpired,
      isSystemError,
      isSomethingError,carouselImages,imageIndex
    } = this.state;
    return (
      <>
        {isPageLoaded && !isSystemError && !isSomethingError && (
          <>
           <div className={`has-background background-new-image ${errorText && "has-error"}`} style={{ backgroundImage: `url(${carouselImages[imageIndex].image})` }}>
            
            <div className="wrapper resend-verification">
            {errorText && <WithError errors={errorText} />}

              <Container
                className={`container wrapper__container ${
                  errorText && "haserror"
                }`}
              >
                <Row>
                  <Col lg={{ span: 6 }}>
                    <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                      {!showSuccessMsg && !showErrorMsg && !verificationTokenExpired && (
                            <>
                            <h1 className="wrapper__container-card-body-title has-desc">
                             {t(
                                  "pages.resendverificationemail.verifyYourEmail"
                                )}
                            </h1>
                            <p className="wrapper__container-card-body-desc">
                            {t("pages.resendverificationemail.verifyYourEmailDesc")}
                            </p>
                              <Form>
                                <Form.Group controlId="loginEmail">
                                  <Form.Label>
                                    {t("pages.resendverificationemail.email")}
                                  </Form.Label>
                                  <Form.Control
                                    type="email"
                                    autoFocus
                                    onChange={(e) => {
                                      this.setState({
                                        mail: e.target.value
                                          .trim()
                                          .toLowerCase()
                                      });
                                      this.isEmailValid(
                                        e.target.value.trim().toLowerCase()
                                      );
                                    }}
                                    value={mail}
                                    className={
                                      emailError ? "error-input" : undefined
                                    }
                                    aria-required
                                    aria-invalid={!!emailError}
                                    aria-describedby="email-error"
                                    ref={this.emailInputRef}
                                  />
                                  <p className="error-text error-text-bottom-space" id="email-error">
                                    {emailError &&
                                      t("common.errors.emailError")}
                                  </p>
                                </Form.Group>

                                <Button
                                  className="wrapper__container-card-body-submit"
                                  size="lg"
                                  variant="primary"
                                  block
                                  type="submit"
                                  onClick={(e) => this.onResendEmail(e)}
                                >
                                  {t("pages.resendverificationemail.send")}
                                </Button>
                              </Form>
                            </>
                          )}

                        {showSuccessMsg && (
                          <div className="notification-card" role="alert" aria-live="polite">
                            <p className="notification-card__text">
                              {t("pages.resendverificationemail.successText")}
                            </p>
                            <p className="notification-card__text">
                              {t("pages.resendverificationemail.subjectTitle")}
                              <span>
                                {t("pages.resendverificationemail.subjectLine")}
                              </span>
                            </p>
                            <p className="notification-card__text">
                              {t(
                                "pages.resendverificationemail.successEmailText"
                              )}
                            </p>
                          </div>
                        )}

                        {showErrorMsg && (
                          <ErrorCard
                            title="pages.resendverificationemail.resendEmailErrorTitle"
                            description="pages.resendverificationemail.resendEmailErrorDesc"
                            anchorText="pages.resendverificationemail.resendEmailErrorlinkText"
                            anchorLink="resendVerificationEmail"
                          />
                        )}

                        {verificationTokenExpired && (
                          <ErrorCard
                            title="pages.resendverificationemail.resendEmailErrorTitle"
                            anchorText="pages.resendverificationemail.resendEmailErrorlinkText"
                            anchorLink="resendVerificationEmail"
                          />
                        )}
                      </div>
                      <div className="separator" />
                      <div className="text-center wrapper__container-card-register">
                        {t("pages.registration.alreadyHaveAccount")}{" "}
                        <Link to={getLoginUrl()}>
                          {t("pages.registration.login")}
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            </div>
          </>
        )}
        {isSystemError  && (
                  <SystemDownTime />
                )}
                {isSomethingError  && (
                  <SomethingWentWrong />
                  
                )}
      </>
    );
  }
}

ResendVerificationEmail.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};
export default withTranslation()(ResendVerificationEmail);
